import { DataBean } from "../DataBean";

export class WorkExperienceAccount extends DataBean {


    public async getWorkExperienceAccountCatalogPorPropiedades(properties:any,maxRows:any): Promise<any> {
        return this.getCustomService("TalentERP", "java.util.List_getWorkExperienceAccountCatalogPorPropiedades_java.util.Map_Number", [properties,maxRows]);
    }

     public async getWorkExperienceAccountReport(page:any,Rows:any,props:any): Promise<any> {
        return this.getCustomService("TalentERP", "com.advantage.shared.Report_getWorkExperienceAccountReport_Number_Number_java.util.Map", [page,Rows,props]);
    }

}